import React from 'react';
import classNames from 'classnames/bind';
import { Skeleton } from "../../../common/Skeleton";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var AppBannerSkeleton = function AppBannerSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: cn('banner'),
    "data-t-id": "components-AppBannerSkeleton"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: cn('title')
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('icons')
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: cn('phone')
  }), /*#__PURE__*/React.createElement(Skeleton, {
    className: cn('qr-code')
  })));
};